import { ApostleLite, ApostleStatus } from '@apeiron/apostle'
import { usePath } from '@apeiron/ui'
import MarketplaceApostleCard from '@src/components/apostles/card/MarketplaceApostleCard'
import FetchedApostleListPersonal from '@src/components/apostles/list/FetchedApostleListPersonal'
import InventorySecNavBar from '@src/components/navigationBar/secondary/InventorySecNavBar'
import InventoryApostleThirdNavBar from '@src/components/navigationBar/third/InventoryApostleThirdNavBar'
import { GAAssetType } from '@src/constants/googleAnalytics'
import { WhiteList } from '@src/constants/page'
import { ROUTE } from '@src/constants/route'
import { useSecondaryNavBarContext } from '@src/contexts/share/SecondaryNavBarContext'
import useTracking from '@src/hooks/common/analytics/useTracking'
import { NextPage } from 'next'
import queryString from 'query-string'
import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const ApostleInventoryPage: NextPage<Props> = () => {
  const { setupBar } = useSecondaryNavBarContext()

  const { replacePath } = usePath(WhiteList)

  const { t } = useTranslation()

  const { gtmEmitSelectItem } = useTracking()

  useEffect(() => {
    setupBar(<InventorySecNavBar index={1} />)

    return () => setupBar(null)
  }, [setupBar])

  const handleUrl = useCallback((apostle: ApostleLite) => {
    const url = queryString.stringifyUrl({
      url: ROUTE.MARKETPLACE_APOSTLE_DETAIL,
      query: {
        apostleId: apostle.id
      }
    })

    return replacePath(url)
  }, [])

  const handleRenderCard = useCallback(
    (apostle: ApostleLite) => {
      const statusText =
        apostle.status === ApostleStatus.Staked
          ? t('apeiron.common.staked')
          : ''

      return (
        <MarketplaceApostleCard
          apostle={apostle}
          key={apostle.id}
          url={handleUrl(apostle)}
          onClick={() => {
            // GA-IB8kdzyFa8p3ina
            gtmEmitSelectItem({
              type: GAAssetType.Apostle,
              item: apostle
            })
          }}
          statusText={statusText}
        />
      )
    },
    [gtmEmitSelectItem, handleUrl, t]
  )

  return (
    <FetchedApostleListPersonal
      thirdNavBar={<InventoryApostleThirdNavBar index={0} />}
      title={t('inventory.title')}
      renderCard={handleRenderCard}
      withTracking
    />
  )
}

type Props = {}

export default ApostleInventoryPage
